import { render, staticRenderFns } from "./promotes.vue?vue&type=template&id=63817364"
import script from "./promotes.vue?vue&type=script&lang=js"
export * from "./promotes.vue?vue&type=script&lang=js"
import style0 from "./promotes.vue?vue&type=style&index=0&id=63817364&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports